import { FC, useEffect } from 'react'
import { useLocation } from 'react-router-dom'

//  const VideoSection = lazy(() => import('./Sections/VideoSection/VideoSection'))
import { isGeDomain } from 'utils/helpers/domains/getDomain'
import { scrollToId } from 'utils/helpers/scrollToId'

import { stepsData } from './PromoPageGe/data'
import { OpeningStepsSection } from './PromoPageGe/Sections/OpeningSteps/OpeningStepsSection'
import { Authorization } from './Sections/Authorization/Authorization'
import Faq from './Sections/Faq/Faq'
import { Banner } from './Sections/Hero/Banner/Banner'
import { Hero } from './Sections/Hero/Hero'
import { KindsOfPickPoints } from './Sections/KindsOfPickPoints/KindsOfPickPoints'
import { MarketPlaceStat } from './Sections/MarketPlaceStat/MarketPlaceStat'
import { OpeningSteps } from './Sections/OpeningSteps/OpeningSteps'
import { PromoLink } from './Sections/PromoLink/PromoLink'
import VideoSection from './Sections/VideoSection/VideoSection'
import { auctionData } from './data'

import videoImg from 'assets/img/video-section/intro-video-preview.png'
import './PromoPage.css'

export const PromoPage: FC = () => {
  const location = useLocation()

  useEffect(() => {
    if (location.hash) {
      setTimeout(() => {
        scrollToId(location.hash)
      }, 100)
    }
  }, [location])

  return (
    <main>
      <Hero />
      <MarketPlaceStat />
      <OpeningSteps />
      <OpeningStepsSection stepsData={stepsData} />
      <PromoLink data={auctionData} isDownloadLink={false} />
      {!isGeDomain() && <Banner />}
      <KindsOfPickPoints />
      <VideoSection
        title="Как открыть пункт выдачи"
        description="Рассказывает руководитель команды открытия ПВЗ Wildberries Алевтина Рожновская"
        poster={videoImg}
        videoSrc="https://static-basket-05.wbbasket.ru/vol114/extdelivery/pvz-wb-ru/video1.mp4"
        useIframe={false}
      />
      <Faq />
      <Authorization />
    </main>
  )
}
